

























import Vue from "vue";
import { myClasses } from "@/api/my";
import _ from "lodash";
import { datetimeFormat } from "@/utils/lang";
import MyClassCard from "@/views/my/MyClassCard.vue";

export default Vue.extend({
    name: "MyClasses",
    components: { MyClassCard },
    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            isPlanFilterShow: false,
            myClassesList: new Array(0),
            finishText: this.$t("home.finishedText"),
            total: 0,
            pagination: {
                size: 10,
                page: 0
            }
        };
    },
    mounted() {
        this.doQuery();
    },
    methods: {
        onLoad() {
            if (this.refreshing) {
                this.myClassesList = [];
                this.refreshing = false;
            }
            this.doQuery();
        },
        doQuery() {
            this.loading = true;
            this.finishText = this.$t("home.finishedText");
            myClasses(this.pagination)
                .then(resp => {
                    if (resp.data) {
                        const pageData = resp.data.data;
                        this.total = resp.data.page.totalElements;
                        if (_.isEmpty(pageData) && _.isEmpty(this.myClassesList)) {
                            this.finishText = "";
                        }
                        if (_.isEmpty(pageData)) {
                            this.finished = true;
                            return;
                        }
                        this.myClassesList = _.concat(this.myClassesList, this.mapperList(pageData));

                        if (this.myClassesList.length <= this.pagination.size) {
                            this.finishText = "";
                        }
                        if (this.myClassesList.length >= this.total) {
                            this.finished = true;
                        }
                    }
                })
                .catch(error => {
                    this.finishText = "";
                    this.finished = true;
                })
                .finally(() => (this.loading = false));
        },
        mapperList(responseData) {
            return _.map(responseData, data => {
                return {
                    id: data.id,
                    klassName: data.klassName,
                    status: data.klassStatus,
                    startAt: datetimeFormat(data.startAt),
                    endAt: datetimeFormat(data.endAt)
                };
            });
        },
        resetPage() {
            this.pagination.size = 10;
            this.pagination.page = 0;
        },
        onRefresh() {
            this.finished = false;
            this.resetPage();
            this.onLoad();
        },
        goClassDetail(payload) {
            this.$router.push(`/my/classes/${payload.classId}/detail`);
        }
    }
});
